import styled from 'styled-components';
import black from 'sushiweb/tokens/color/black';
import red from 'sushiweb/tokens/color/red';
import white from 'sushiweb/tokens/color/white';
import { P } from 'sushiweb/Typography/Text';
import Input from 'sushiweb/InputTypes/Input';
import Layout from 'sushiweb/Layout';
import { grey } from 'sushiweb/tokens/color';

export const StyledLayout = styled(Layout)`
  max-height: 50rem;
  /* overflow-y: scroll; */
  position: relative;
  ::-webkit-scrollbar {
    display: none;
  }
  display: flex;
  align-items: center;
  h6 {
    justify-content: flex-end;
  }
`;

export const StyledP = styled(P)`
  font-size: 1.8rem;
  font-weight: 400;
  color: '#1C1C1C';
  margin-bottom: 1.5rem;
`;

export const CreateButtonWrapper = styled.div`
  margin: 0rem 2.8rem 2.2rem 2.8rem;
  display: flex;
  justify-content: space-between;
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-content: stretch;
  justify-content: center;
  align-items: stretch;
  position: fixed;
  bottom: 0;
  width: 100%;
  background: ${white};
  left: 0;
  padding: 0rem 0rem 1.2rem 0rem;
  box-shadow: 0px -1px 20px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  border-radius: 0 0 0.6rem 0.6rem;
`;

export const ConfirmLabel = styled.div`
  display: flex;
  margin: 1rem 1rem 1rem 2rem;
  input {
    margin: 0.6rem 1.2rem 0 0;
    cursor: pointer;
    width: 1.8rem;
    height: 1.8rem;
    border-color: ${red.z400};
  }
  input:checked {
    border-color: ${red.z400};
    background: ${red.z400};
  }
  input:hover {
    border-color: ${red.z400};
  }
  p {
    padding-top: 0.2rem;
    font-size: 1.6rem;
    color: ${black};
  }
`;

export const WarningContainer = styled.div`
  text-align: center;
  padding: 0.5rem 1rem;
  background: ${red.z100};
  color: ${red.z500};
  border: 1px solid ${red.z200};
  border-radius: 0.4rem;
  font-size: 1.3rem;
  font-weight: 500;
`;

export const FormWrapper = styled.div`
  width: 70rem;
  padding: 1rem 9rem 7.2rem 2.4rem;
`;

export const StyledInput = styled(Input)`
  input {
    width: 90% !important;
  }
`;
export const StyledDisabledInput = styled(Input)`
  input {
    width: 100%;
  }
  input:disabled {
    color: ${black};
    background-color: ${grey.z100};
    border-color: ${grey.z200};
  }
  label {
    color: ${grey.z700};
  }
`;

export const ReviewPlanButtonWrapper = styled.div`
  padding: 20px;
  margin-top: 1.5rem;
  display: flex;
  justify-content: space-between;
`;
